import { useEffect, useMemo, useRef, useState } from "react";
import constate from "constate";
import { initializeApp } from "firebase/app";

import { FIREBASE_CONFIGS } from "./constants";
import {
  fetchAndActivate,
  getRemoteConfig,
  getString
} from "firebase/remote-config";

const FirebaseState = () => {
  // States
  const [ready, setIsReady] = useState(false);
  const [remoteConfigReady, setRemoteConfigReady] = useState(false);

  // Refs
  const firebaseAppRef = useRef(null);
  const remoteConfigRef = useRef(null);

  // Memos
  const remoteConfig = useMemo(
    () => ({
      ready: remoteConfigReady,
      getString: key =>
        remoteConfigReady ? getString(remoteConfigRef.current, key) : undefined
    }),
    [remoteConfigReady]
  );

  // Effects
  useEffect(() => {
    const initialize = async () => {
      try {
        firebaseAppRef.current = initializeApp({
          ...FIREBASE_CONFIGS[process.env.REACT_APP_ENVIRONMENT],
          apiKey: process.env.REACT_APP_FIREBASE_API_KEY
        });
        remoteConfigRef.current = getRemoteConfig();
        remoteConfigRef.current.settings.minimumFetchIntervalMillis =
          process.env.REACT_APP_ENVIRONMENT === "prod" ? 3600000 : 300000;

        await fetchAndActivate(remoteConfigRef.current);
        setIsReady(true);
        setRemoteConfigReady(true);
      } catch (error) {
        console.log(error);
      }
    };
    initialize();
  }, []);

  return { ready, remoteConfig };
};

const [FirebaseProvider, useFirebase, useFirebaseRemoteConfig] = constate(
  FirebaseState,
  state => state,
  state => state.remoteConfig
);

export default FirebaseProvider;

export { useFirebase, useFirebaseRemoteConfig };
